import { render, staticRenderFns } from "./IconLoader.vue?vue&type=template&id=7b6a4cb0&"
import script from "./IconLoader.vue?vue&type=script&lang=js&"
export * from "./IconLoader.vue?vue&type=script&lang=js&"
import style0 from "./IconLoader.vue?vue&type=style&index=0&lang=scss&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./IconLoader.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./IconLoader.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js").rerender("7b6a4cb0")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6a4cb0')) {
      api.createRecord('7b6a4cb0', component.options)
    } else {
      api.reload('7b6a4cb0', component.options)
    }
    module.hot.accept("./IconLoader.vue?vue&type=template&id=7b6a4cb0&", function () {
      api.rerender('7b6a4cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loader/IconLoader.vue"
export default component.exports